__turbopack_context__.v({
  "container": "volumeTable-module-scss-module__HPZcPW__container",
});
